import {
  clientPaths,
  isCommunityDetailPath,
  isEventGamePath,
  isEventStatistikPath,
  isPath,
  isPathPrefix,
  normalizePathname,
} from '@/utils/clientPaths';

export function getHeaderTitle(pathname: string): { title: string; subtitle?: string; isSubpage: boolean } {
  const path = normalizePathname(pathname);
  if (path === '/cash' || path.startsWith('/cash')) {
    return {
      title: 'Cashflow Management',
      subtitle: 'Pemasukan event ikut status pembayaran',
      isSubpage: true,
    };
  }
  if (isPathPrefix(path, clientPaths.event.create)) {
    return { title: 'Buat Sesi Mabar', isSubpage: true };
  }
  if (path.startsWith('/event/edit/')) {
    return { title: 'Edit Sesi Mabar', isSubpage: true };
  }
  if (path.startsWith('/event/dashboard/')) {
    return { title: 'Dashboard Mabar', isSubpage: true };
  }
  if (path.startsWith('/event/checkout')) {
    return { title: 'Checkout Event', isSubpage: true };
  }
  if (path.includes('/manage-share')) {
    return { title: 'Kelola Statistik Rapor', isSubpage: true };
  }
  if (path.includes('/badminton/tambah-game')) {
    return { title: 'Tambah Game', isSubpage: true };
  }
  if (/\/event\/[^/]+\/badminton\/game\//.test(path)) {
    return { title: 'Edit Skor', isSubpage: true };
  }
  if (/\/event\/[^/]+\/badminton/.test(path)) {
    return { title: 'Statistik Event', isSubpage: true };
  }
  if (path.includes('/padel/tambah-game')) {
    return { title: 'Tambah Game Padel', isSubpage: true };
  }
  if (/\/event\/[^/]+\/padel\/game\//.test(path)) {
    return { title: 'Edit Skor', isSubpage: true };
  }
  if (/\/event\/[^/]+\/padel/.test(path)) {
    return { title: 'Statistik Event', isSubpage: true };
  }
  if (/\/event\/[^/]+\/pickleball/.test(path)) {
    return { title: 'Statistik Event', isSubpage: true };
  }
  if (isEventStatistikPath(path) || isEventGamePath(path)) {
    return { title: 'Hasil Mabar', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.password)) {
    return { title: 'Ganti Password', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.stats)) {
    return { title: 'Informasi Statistik', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.accountDelete)) {
    return { title: 'Hapus Akun', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.manageCommunities)) {
    return { title: 'Kelola Komunitas', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.account)) {
    return { title: 'Pengaturan Akun', isSubpage: true };
  }
  if (path === clientPaths.event.list) {
    return { title: 'Event', isSubpage: false };
  }
  if (pathname.includes('/participants') || pathname.includes('/pemain')) {
    return { title: 'Pemain Terdaftar', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.event.list)) {
    return { title: 'Detail Event', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.myCommunity)) {
    return { title: 'Komunitas Saya', isSubpage: true };
  }
  if (pathname.includes('/members')) {
    return { title: 'Daftar Anggota', isSubpage: true };
  }
  if (pathname.includes('/events')) {
    return { title: 'Semua Event', isSubpage: true };
  }
  if (isPath(path, clientPaths.arena.payment)) {
    return { title: 'Pembayaran & Review', isSubpage: true };
  }
  if (isPath(path, clientPaths.arena.checkout)) {
    return { title: 'Instruksi Pembayaran', isSubpage: true };
  }
  if (isPath(path, clientPaths.arena.paymentSuccess)) {
    return { title: 'Pembayaran Berhasil', isSubpage: true };
  }
  if (
    (isPathPrefix(path, '/arena') && path !== '/arena') ||
    (isPathPrefix(path, clientPaths.discovery.arena) && path !== clientPaths.discovery.arena)
  ) {
    return { title: 'Detail Arena', isSubpage: true };
  }
  if (isCommunityDetailPath(path)) {
    return { title: 'Detail Komunitas', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.discovery.root)) {
    return { title: 'Discovery', isSubpage: false };
  }
  if (isPathPrefix(path, clientPaths.mmr.leaderboard)) {
    return { title: 'Papan Peringkat', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.profile.mmr)) {
    return { title: 'Detail MMR', isSubpage: true };
  }
  if (isPathPrefix(path, clientPaths.booking.list) && path !== clientPaths.booking.list) {
    return { title: 'Detail Booking', isSubpage: true };
  }
  if (path === clientPaths.booking.list) {
    return { title: 'Booking', isSubpage: false };
  }
  if (isPathPrefix(path, clientPaths.transactions.list)) {
    const isDetail = path !== clientPaths.transactions.list;
    return { title: isDetail ? 'Detail Transaksi' : 'Riwayat Transaksi', isSubpage: true };
  }
  if (isPath(path, clientPaths.profile.settings)) {
    return { title: 'Profil', isSubpage: false };
  }
  if (isPath(path, clientPaths.notification)) {
    return { title: 'Notifikasi', isSubpage: true };
  }
  return { title: 'Sporto', isSubpage: false };
}
